<template>
  <div>
    <div class="projects-li add-project" @click="dialogVisible = true">
      <i class="el-icon-plus"></i>
      <span>Добавить проект</span>
      <i class="fas fa-chevron-right"></i>
    </div>
    <el-dialog
      v-loading="loading"
      title="Добавить новый проект"
      :visible.sync="dialogVisible"
    >
      <el-form>
        <el-form-item label="Название проекта">
          <el-input v-model="form.name" placeholder/>
        </el-form-item>
        <el-form-item label="Адрес проекта">
          <el-input v-model="form.address"/>
        </el-form-item>
        <el-form-item label="Описание  проекта">
          <el-input v-model="form.description" type="textarea" textarea/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">Отменить</el-button>
      <el-button type="primary" @click="save" :disabled="loading">Добавить</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import dayjs from 'dayjs';
import {getDemoUser} from "../../../../firestore/demo";

export default {
  name: 'AddProject',
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        name: '',
        address: '',
        description: '',
      },
      user: null,
    };
  },

  mounted() {
    this.fetchUser();
  },

  methods: {
    async fetchUser() {
      if (this.$store.state.project.id) {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .where('uid', '==', firebase.auth().currentUser.uid)
          .get()
          .then((data) => {
            data.forEach((subDoc) => {
              this.user = subDoc.data();
            });
          });
      } else {
        this.user = await getDemoUser(firebase.auth().currentUser.uid);
      }
    },
    save() {
      this.loading = true;

      firebase.firestore()
        .collection('projects')
        .add({
          ...this.form,
          tasks: true,
          owner: firebase.auth().currentUser.uid,
          start_date: dayjs(dayjs().utc().format('YYYY-MM-DD')).unix(),
          end_date: dayjs(dayjs().utc().add(30, 'days').format('YYYY-MM-DD')).unix(),
          rules: {
            [firebase.auth().currentUser.uid]: 'admin',
          },
        }).then(async (add) => {
        if (this.user) {
          await firebase.firestore()
            .collection('projects')
            .doc(add.id)
            .collection('users')
            .add({
              email: firebase.auth().currentUser.email,
              uid: firebase.auth().currentUser.uid,
              position: '',
              ...this.user,
              role: 'admin',
            });
        } else {
          await firebase.firestore()
            .collection('projects')
            .doc(add.id)
            .collection('users')
            .add({
              uid: firebase.auth().currentUser.uid,
              position: '',
              name: '',
              email: firebase.auth().currentUser.email,
              phone: '',
              company: '',
              role: 'admin',
            });
        }

        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Новый проект добавлен',
          type: 'success',
        });
        this.loading = false;
        this.$emit('new-project', {
          id: add.id,
          tasks: true,
          ...this.form,
        });
        this.dialogVisible = false;
        this.form = {
          name: '',
          address: '',
          description: '',
        };
      }).catch((error) => {
        console.error(error);
        this.loading = false;
        this.$notify({
          offset: 60,

          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Dashboard/Projects/components/AddProject.vue